import React from 'react'
import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  Users,
  Wrench
} from 'lucide-react'

const BottomNav: React.FC = () => {
  const navItems = [
    {
      name: 'Dashboard',
      href: '/dashboard',
      icon: LayoutDashboard
    },
    {
      name: 'Clientes',
      href: '/clientes',
      icon: Users
    },
    {
      name: 'OS',
      href: '/ordens-servico',
      icon: Wrench
    }
  ]

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 safe-area-inset-bottom">
      <div className="grid grid-cols-3 h-16">
        {navItems.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            className={({ isActive }) => `
              flex flex-col items-center justify-center gap-1
              transition-colors duration-200
              ${isActive
                ? 'text-primary-600 bg-primary-50'
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
              }
            `}
          >
            {({ isActive }) => (
              <>
                <item.icon className={`h-6 w-6 ${isActive ? 'text-primary-600' : 'text-gray-500'}`} />
                <span className={`text-xs font-medium ${isActive ? 'text-primary-600' : 'text-gray-600'}`}>
                  {item.name}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}

export default BottomNav
